import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_BANK_ACCOUNT_DETAIL = 'INVESTMENT/FETCH_BANK_ACCOUNT_DETAIL';

const apiCall = createApiCall(
  FETCH_BANK_ACCOUNT_DETAIL,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/bank-accounts/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
